import React, { createContext, useState } from 'react'

const TopbarContext =  createContext()

function useTopbarProvider(){
    const [title, setTitle] = useState('Home');
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const setTopTitle = (topTitle) =>{
        setTitle(topTitle)
    }

    const setSidebar = (status) =>{
        setSidebarOpen(status)
    }

    return { title, isSidebarOpen, setTopTitle, setSidebar }
}

function TopbarProvider(props){
    const topbar = useTopbarProvider()

    return(
        <TopbarContext.Provider value={topbar}>
            {props.children}
        </TopbarContext.Provider>
    )
}

export { TopbarProvider, TopbarContext }